import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils/utils';
import { Button } from '@/components/ui/button';
import { FileText, Coins, Settings, HelpCircle, Shield, ClipboardList } from 'lucide-react';
import TokenManagementContent from './superadmin/TokenManagementContent';
import DefaultPermissionsContent from './superadmin/DefaultPermissionsContent';
import AdminProceduresContent from './superadmin/AdminProceduresContent';
import AppManagementContent from './superadmin/AppManagementContent';
import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';

function getSubTabs() {
    return [
        { value: 'articles', label: i18n.t('account:gestionDesArticles'), icon: FileText, disabled: true },
        { value: 'tokens', label: i18n.t('account:gestionDesJetons'), icon: Coins },
        { value: 'app', label: i18n.t('account:gestionDeLApp'), icon: Settings },
        { value: 'faq', label: i18n.t('account:gestionDesFaq'), icon: HelpCircle, disabled: true },
        { value: 'permissions', label: i18n.t('account:autorisationsSousComptes'), icon: Shield },
        { value: 'procedures', label: i18n.t('account:proceduresTypes2'), icon: ClipboardList },
    ];
}

const VALID_SUB_TABS = getSubTabs().map((t) => t.value);

export default function SuperAdminTabContent() {
    const { t } = useTranslation();
    const SUB_TABS = getSubTabs();
    const { subTab } = useParams();
    const navigate = useNavigate();
    const activeSubTab = VALID_SUB_TABS.includes(subTab) ? subTab : 'tokens';

    const handleSubTabChange = (value) => {
        navigate(`/settings/superadmin/${value}`, { replace: true });
    };

    return (
        <div className="px-5 py-6 space-y-5">
            {/* Sub-tab navigation */}
            <div className="bg-card rounded-xl border border-border overflow-hidden">
                <div className="flex gap-1 p-2 overflow-x-auto scrollbar-hide">
                    {SUB_TABS.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = activeSubTab === tab.value;
                        return (
                            <Button
                                key={tab.value}
                                variant={isActive ? 'solid' : 'plain'}
                                color={isActive ? 'secondary' : 'neutral'}
                                size="xlg"
                                disabled={tab.disabled}
                                onClick={() => !tab.disabled && handleSubTabChange(tab.value)}
                                className={cn('text-[13px] whitespace-nowrap', !isActive && 'text-muted-foreground')}
                            >
                                <Icon className="h-4 w-4" />
                                {tab.label}
                            </Button>
                        );
                    })}
                </div>
            </div>

            {/* Sub-tab content */}
            <div className="bg-card rounded-2xl border border-border">
                {activeSubTab === 'tokens' && (
                    <div className="p-5">
                        <TokenManagementContent />
                    </div>
                )}

                {activeSubTab === 'permissions' && <DefaultPermissionsContent />}

                {activeSubTab === 'articles' && (
                    <div className="text-muted-foreground text-sm py-8 text-center">{t('account:gestionDesArticlesAVenir')}</div>
                )}

                {activeSubTab === 'app' && (
                    <div className="p-5">
                        <AppManagementContent />
                    </div>
                )}

                {activeSubTab === 'faq' && (
                    <div className="text-muted-foreground text-sm py-8 text-center">{t('account:gestionDesFaqAVenir')}</div>
                )}

                {activeSubTab === 'procedures' && <AdminProceduresContent />}
            </div>
        </div>
    );
}
